import { AppleNotesStepsMap } from "./steps/AppleNotesSteps";
import { ObsidianStepsMap } from "./steps/ObsidianSteps";
import { OtherAppsStepsMap } from "./steps/OtherAppsSteps";
import { NotesApp, StepMap } from "./ImportWizard.types";
import { AppSelectionStep } from "@/components/onboarding/components/ImportWizard/AppSelectionStep";
import { SkipConfirmationStep } from "@/components/onboarding/components/ImportWizard/steps/SkipConfirmationStep";

export const NotesApps: NotesApp[] = [
  {
    id: "apple-notes",
    title: "Apple Notes",
    iconImage: "/onboarding/apple-notes.png",
  },
  {
    id: "obsidian",
    title: "Obsidian",
    iconImage: "/onboarding/obsidian-icon.png",
  },
  {
    id: "other",
    title: "Other",
  },
  {
    id: "none",
    title: "I don't currently use a notes app",
    omitFromTabs: true,
  },
] as const;

export const Steps: StepMap = {
  "app-selection": {
    render: ({
      selectedAppId,
      customAppName,
      onNavToStep,
      onSetSelectedApp,
      onSetCustomAppName,
    }) => (
      <AppSelectionStep
        selectedAppId={selectedAppId}
        customAppName={customAppName}
        onAppSelect={onSetSelectedApp}
        onCustomAppNameChange={onSetCustomAppName}
        onNavToStep={onNavToStep}
      />
    ),
  },
  "skip-confirmation": {
    render: ({ onClose, onNavToStep }) => (
      <SkipConfirmationStep onClose={onClose} onNavToStep={onNavToStep} />
    ),
  },
  ...AppleNotesStepsMap,
  ...ObsidianStepsMap,
  ...OtherAppsStepsMap,
} as const;
